import axios from 'axios';

const API_URL = '/api/healthdata';

export const fetchHealthData = async (userId) => {
  try {
    const response = await axios.get(`${API_URL}/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching health data:", error);
    throw error;
  }
}

export const createHealthData = async (healthData) => {
  try {
    const response = await axios.post(API_URL, healthData);
    return response.data;
  } catch (error) {
    console.error("Error creating health data:", error);
    throw error;
  }
}

export const updateHealthData = async (user_id, healthData) => {
  try {
    const response = await axios.put(`${API_URL}/${user_id}`, healthData);
    return response.data;
  } catch (error) {
    console.error("Error updating health data:", error);
    throw error;
  }
};

export const fetchAllergies = async (userId) => {
  try {
    const response = await axios.get(`${API_URL}/${userId}/allergies`);
    return response.data;
  } catch (error) {
    console.error("Error fetching allergies:", error);
    throw error;
  }
};
